// import { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

// export const useProjectZones = (zoneId = "sadan") => {
//   const [projectData, setProjectData] = useState(null);

//   useEffect(() => {
//     const fetchProject = async () => {
//       try {
//         const res = await axios.get(`${BASE_URL}/zones/${zoneId}`, {
//           headers: DEFAULT_HEADERS,
//         });
//         setProjectData(res.data.data);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchProject();
//   }, [zoneId]);

//   return projectData;
// };




// import { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";
// export const useProjectZones = (zoneId, lang) => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   console.log("useProjectZones called with lang:", lang, "zoneId:", zoneId);
//   useEffect(() => {
//     if (!zoneId) {
//       setLoading(false);
//       return;
//     }

//     const fetchProject = async () => {
//       try {
//         const res = await axios.get(`${BASE_URL}/zones/${zoneId}`, {
//           headers: DEFAULT_HEADERS,
//           params: {
//             lang, // 👈 هنا بالظبط
//           },
//         });

//         setProjectData(res.data.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err);
//         setLoading(false);
//       }
//     };

//     fetchProject();
//   }, [zoneId, lang]);

//   return { projectData, loading, error };
// };
// 7/4





import { useState, useEffect, useMemo } from "react"; // أضفنا useMemo
import axios from "axios";
import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

export const useProjectZones = (zoneId, lang) => {
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!zoneId) {
      setLoading(false);
      return;
    }

    const fetchProject = async () => {
      // لا نجعل loading = true هنا إلا لو الـ zoneId تغير فعلاً لتجنب الوميض (Flicker)
      try {
        const res = await axios.get(`${BASE_URL}/zones/${zoneId}`, {
          headers: DEFAULT_HEADERS,
          params: { lang },
        });

        // تحقق بسيط: لا تقم بتحديث الحالة إذا كانت البيانات هي نفسها (Deep Compare اختياري)
        setProjectData(res.data.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchProject();
  }, [zoneId, lang]);

  // استخدام useMemo لضمان أن المرجع (Reference) لا يتغير إلا بتغير البيانات الحقيقية
  return useMemo(() => ({ projectData, loading, error }), [projectData, loading, error]);
};













// import { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

// // 1. ضيفنا الـ projectSlug كـ parameter
// // 1. استلمي الـ parameters جوه { } عشان الترتيب ميبقاش مهم
// export const useProjectZones = ({ zoneId, lang, projectSlug }) => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // 2. الحماية: لو الـ projectSlug لسه مجاش، متبعتش request
//     if (!projectSlug || projectSlug === "undefined" || !zoneId) {
//       console.warn("⚠️ Waiting for valid projectSlug or zoneId...");
//       return;
//     }

//     const fetchProject = async () => {
//       try {
//         setLoading(true);
//         // التأكد من شكل الـ URL
//         const res = await axios.get(`${BASE_URL}/projects/${projectSlug}/zones/${zoneId}`, {
//           headers: DEFAULT_HEADERS,
//           params: { lang },
//         });

//         setProjectData(res.data.data);
//       } catch (err) {
//         console.error("❌ Error fetching zone data:", err);
//         setError(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProject();
//   }, [zoneId, lang, projectSlug]);

//   return { projectData, loading, error };
// };
// export const useProjectZones = (zoneId) => {


//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);     // جديد
//   const [error, setError] = useState(null);         // جديد

//   useEffect(() => {
//     if (!zoneId) {
//       setLoading(false);
//       return;
//     }

//     const fetchProject = async () => {
//       try {
//         // console.log("جاري جلب الداتا لـ zoneId:", zoneId); // مهمة جدًا
//         const res = await axios.get(`${BASE_URL}/zones/${zoneId}`, {
//           headers: DEFAULT_HEADERS,
//         });
//         // console.log("الداتا وصلت بنجاح:", res.data); // مهمة جدًا
//         setProjectData(res.data.data);
//         setLoading(false);
//       } catch (err) {
//         // console.error("خطأ في جلب الداتا:", err.response || err);
//         setError(err);
//         setLoading(false);
//       }
//     };

//     fetchProject();
//   }, [zoneId]);

//   return { projectData, loading, error }; // رجّع object مش بس projectData
// };